// The words on a task's buttons: Give consent's two, and Read this's one.

import { InfoDot } from '../hiring/HiringForm';
import { FIELD_INPUT, FieldLabel } from './bannerFormBits';
import { MAX_BUTTON_WORDS, type TaskButtons } from './useTaskButtons';

/** Give consent: Agree, Decline, and whether they may decline at all. */
export function ConsentFields({ buttons }: { buttons: TaskButtons }) {
  const { agreeWords, setAgreeWords, declineWords, setDeclineWords, allowDecline, setAllowDecline } = buttons;
  return (
    <>
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="min-w-0">
          <FieldLabel text="Agree button" htmlFor="banner-agree-words" />
          <input
            id="banner-agree-words"
            type="text"
            value={agreeWords}
            onChange={(e) => setAgreeWords(e.target.value)}
            maxLength={MAX_BUTTON_WORDS}
            className={FIELD_INPUT}
          />
        </div>
        {allowDecline && (
          <div className="min-w-0">
            <FieldLabel text="Decline button" htmlFor="banner-decline-words" />
            <input
              id="banner-decline-words"
              type="text"
              value={declineWords}
              onChange={(e) => setDeclineWords(e.target.value)}
              maxLength={MAX_BUTTON_WORDS}
              className={FIELD_INPUT}
            />
          </div>
        )}
      </div>
      <div className="flex items-center gap-1">
        <label className="flex cursor-pointer items-center gap-2 text-sm text-gray-700">
          <input
            type="checkbox"
            checked={allowDecline}
            onChange={(e) => setAllowDecline(e.target.checked)}
            className="h-4 w-4 rounded border-gray-300 accent-primary-600 focus:ring-primary-500"
          />
          Let them decline
        </label>
        <InfoDot text="A decline ends the ask: the banner goes, and the tracker shows Declined. Off, they have only the Agree button." />
      </div>
    </>
  );
}

/** Read this: the button's words. */
export function ReadThisFields({ buttons }: { buttons: TaskButtons }) {
  const { buttonWords, setButtonWords } = buttons;
  return (
    <div className="sm:max-w-[calc(50%-6px)]">
      <FieldLabel
        text="Button words"
        htmlFor="banner-button-words"
        hint="Pressing it marks it done, on the new app. An older app has no button: a plain banner until its date."
      />
      <input
        id="banner-button-words"
        type="text"
        value={buttonWords}
        onChange={(e) => setButtonWords(e.target.value)}
        maxLength={MAX_BUTTON_WORDS}
        className={FIELD_INPUT}
      />
    </div>
  );
}
